export interface SsoDiscourseParams {
  sso: string;
  sig: string;
}

/**
 * Why the server refused a community sign-in, for the refusals the client should
 * handle as expected rather than report. `error` keeps its text beside this, so a
 * client that predates the code still sees an error and reports it as before.
 */
export enum SsoDiscourseErrorCode {
  /** the person has no active subscription; the forum is for subscribers only (#6608) */
  NotSubscribed = 'NotSubscribed',
}

export interface SsoDiscourseResults {
  error?: string;
  errorCode?: SsoDiscourseErrorCode;
  redirectUrl?: string;
}
